import {TimeInterval} from '@birco/rainmesh-api';

export function formatStatisticsTooltipDate(timestamp: string, interval: TimeInterval | null, locale: string): string {
  const date = new Date(timestamp);

  if (Number.isNaN(date.getTime())) {
    return timestamp;
  }

  switch (interval) {
    case TimeInterval.MONTHLY:
      return date.toLocaleDateString(locale, {month: 'long'});
    case TimeInterval.DAILY:
      return date.toLocaleDateString(locale, {day: '2-digit', month: '2-digit', year: 'numeric'});
    case TimeInterval.HOURLY:
    default:
      return date.toLocaleString(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
  }
}
